import React, { useEffect } from 'react'
import Navbar from "../../Components/Navbar";
import { projects6Mockup1, projects6Mockup2, AstrattoBanner } from '../../Assets';


const Project6Details = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <div className='project-details-app-main-wrapper'>
                <Navbar />
                <div className="projects-details-cover-wrapper">
                    <div className="container">
                        <div className="project-details-content-cover">
                            <div className='project-det-hero-cover'>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <div className='project-det-title'>
                                            <h3>Astratto
                                            </h3>
                                            <div className="project-infographics-cover">
                                                <div className="project-info-pills-cover">
                                                    <div className="project-info-pills">
                                                        <p>Sept 2024</p>
                                                    </div>
                                                    <div className="project-info-pills">
                                                        <p>Link</p>
                                                    </div>
                                                    <div className="project-info-pills">
                                                        <p>Client Project</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className='project-det-short-summary'>
                                            <p>A React app for seamless expense management. Track, categorize, and analyze your spending effortlessly. User-friendly interface, real-time updates, and insightful reports for better financial control. Simplify budgeting with Expend Tracker.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='projects-det-cards-cover'>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="proj-small-card-cover">
                                            <div className="proj-small-card">
                                                <img src={projects6Mockup2}></img>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="proj-high-card-cover">
                                            <div className="proj-small-card">
                                                <img src={AstrattoBanner}></img>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="proj-small-card-cover">
                                            <div className="proj-small-card">
                                                <img src={projects6Mockup1}></img>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="projects-description-cover-box">

                                <div className="projects-description-content-cover">
                                    <div className="row">
                                        <div className="col-lg-8">
                                            <div className="projects-description-content-box">
                                                <div className="projects-title-header">
                                                    <h2>Project Description</h2>
                                                </div>
                                                <div className="projects-description-content">
                                                    <p>Astratto Production House

                                                         a premier production house nestled in the vibrant city of Bangalore. With seven years of industry experience, we specialize in crafting high-quality visual content that tells compelling stories and captures the essence of our clients' visions.

                                                    </p>

                                                    <p>
                                                        Our dedicated team of professionals—comprising talented cinematographers, certified drone operators, seasoned producers, and creative minds—works collaboratively to transform ideas into stunning visual narratives. Each member brings their unique expertise, ensuring that every project is executed with precision and creativity.

                                                        At Astratto, we are committed to excellence, creativity, and innovation. Our goal is to create content that resonates with audiences and leaves a lasting impact. Let us bring your vision to life!
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4'>
                                            <div className="projects-skills-cover">
                                                <h5>Skills</h5>
                                                <div className='projects-skills-pills-cover'>
                                                    <div className='project-skills-pills'>
                                                        <p>Firebase</p>
                                                    </div>
                                                    <div className='project-skills-pills'>
                                                        <p>Forms</p>
                                                    </div>
                                                    <div className='project-skills-pills'>
                                                        <p>Context Api</p>
                                                    </div>
                                                    <div className='project-skills-pills'>
                                                        <p>React Hooks</p>
                                                    </div>
                                                    <div className='project-skills-pills'>
                                                        <p>useEffect Hooks</p>
                                                    </div>
                                                    <div className='project-skills-pills'>
                                                        <p>React Router Dom</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Project6Details